import Divider from 'components/Divider';
import Modal from 'components/shared/Modal';
import { creditStore } from 'entities/credit';
import { FC, useState, useEffect } from 'react';
import { FilledButton, OutlinedButton, SingleCheckBox } from 'shared/ui';
import store from 'store';

export const SecondsExhaustedModal: FC = () => {
  const [skipModal, setSkipModal] = useState<boolean>(
    store.get('skipSecondsExhaustedModal', false)
  );
  const { open, setIsSecondsExhaustedModal, onContinue } = creditStore(
    (state) => ({
      open: state.isSecondsExhaustedModal,
      onContinue: state.secondsExhaustedCallbackContinue,
      setIsSecondsExhaustedModal: state.setIsSecondsExhaustedModal
    })
  );

  const [localSkipModal, setLocalSkipModal] = useState<boolean>(skipModal);

  useEffect(() => {
    if (open && skipModal) {
      onContinue && onContinue();
    }
  }, [open, skipModal, onContinue]);

  const handleSkipModal = () => {
    const newValue = !localSkipModal;
    setLocalSkipModal(newValue);
  };

  const handleContinue = () => {
    if (localSkipModal) {
      store.set('skipSecondsExhaustedModal', true);
      setSkipModal(true);
    }
    onContinue && onContinue();
  };

  if (skipModal && !open) {
    return null;
  }

  return (
    <Modal
      open={open && !skipModal}
      setOpen={(value) => !value && setIsSecondsExhaustedModal(false)}
      className="!ag-w-[24rem]"
      noPadding
    >
      <div>
        <h3 className="ag-text-lg ag-font-semibold ag-py-5 ag-text-center">
          Seconds Exhausted
        </h3>
        <Divider />
        <div className="ag-p-4">
          <p className="ag-text-sm ag-text-gray-700">
            You do not have any seconds. During May, minutes will cost only{' '}
            <b>$0.20</b> per minute, billed by the second{' '}
            <b>($0.0033 per second)</b>. Bulk seconds purchasing is coming soon.
          </p>
          <div className="ag-flex ag-py-0.5 ag-gap-3 ag-items-center ag-my-1">
            <SingleCheckBox
              label="Don’t show me this again."
              onClick={handleSkipModal}
              value={localSkipModal}
              className="yep_ex-text-neutral-700 yeo_ex-font-medium yep_ex-leading-normal"
            />
          </div>
          <div className="ag-mt-4 ag-flex ag-justify-center ag-gap-4">
            <OutlinedButton
              className="ag-flex-1 focus:ag-outline-primary-600 ag-px-4 ag-py-2.5"
              onClick={() => setIsSecondsExhaustedModal(false)}
            >
              Cancel
            </OutlinedButton>
            <FilledButton
              className="ag-flex-1"
              type="button"
              onClick={handleContinue}
            >
              Continue
            </FilledButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};
